import React__default from 'react';
import { isObject } from '@aws-amplify/ui';
import { FileStatus } from '../../types.mjs';
import { storageManagerStateReducer } from './reducer.mjs';
import { addFilesAction, clearFilesAction, queueFilesAction, setUploadingFileAction, setProcessedKeyAction, setUploadProgressAction, setUploadStatusAction, removeUploadAction } from './actions.mjs';

const isDefaultFile = (file) => !!(isObject(file) && file.key);
const createFileFromDefault = (file) => isDefaultFile(file)
    ? { ...file, id: file.key, status: FileStatus.UPLOADED }
    : undefined;
function useStorageManager(defaultFiles = []) {
    const [{ files }, dispatch] = React__default.useReducer(storageManagerStateReducer, {
        files: (Array.isArray(defaultFiles)
            ? defaultFiles.map(createFileFromDefault).filter((file) => !!file)
            : []),
    });
    const addFiles = ({ files, status, getFileErrorMessage, }) => {
        dispatch(addFilesAction({ files, status, getFileErrorMessage }));
    };
    const clearFiles = () => {
        dispatch(clearFilesAction());
    };
    const queueFiles = () => {
        dispatch(queueFilesAction());
    };
    const setUploadingFile = ({ uploadTask, id, }) => {
        dispatch(setUploadingFileAction({ id, uploadTask }));
    };
    const setProcessedKey = (input) => {
        dispatch(setProcessedKeyAction(input));
    };
    const setUploadProgress = ({ progress, id, }) => {
        dispatch(setUploadProgressAction({ id, progress }));
    };
    const setUploadSuccess = ({ id }) => {
        dispatch(setUploadStatusAction({ id, status: FileStatus.UPLOADED }));
    };
    const setUploadPaused = ({ id }) => {
        dispatch(setUploadStatusAction({ id, status: FileStatus.PAUSED }));
    };
    const setUploadResumed = ({ id }) => {
        dispatch(setUploadStatusAction({ id, status: FileStatus.UPLOADING }));
    };
    const removeUpload = ({ id }) => {
        dispatch(removeUploadAction({ id }));
    };
    return {
        removeUpload,
        setProcessedKey,
        setUploadPaused,
        setUploadProgress,
        setUploadResumed,
        setUploadSuccess,
        setUploadingFile,
        queueFiles,
        addFiles,
        clearFiles,
        files,
    };
}

export { useStorageManager };
